import { useQuery } from '@tanstack/react-query';

import { KimLhcService } from '@/infra/services/kim-lhc';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetKimLhcParams {
	file_id: string;
	company_id: string;
	organization_id: string;
}

const Service = KimLhcService.getInstance();

export const useGetKimLhc = (params: GetKimLhcParams) => {
	const isEnabled = !!params.file_id && !!params.company_id && !!params.organization_id;

	return useQuery({
		queryKey: [QUERY_KEYS.GET_KIM_LHC, params.file_id],
		queryFn: async () => Service.show(params),
		enabled: isEnabled
	});
};
